import * as yup from 'yup'

const requestTerminalSchema = yup.object().shape({
      pmAccount: yup.string().required("PM account is required"),
      location: yup.string().required("Location is required"),
})

export default requestTerminalSchema;